import React from 'react'
import VideoConference from '../Components/VideoConference/VideoConference'

const VideoConferencePage = () => {
  return (
    <VideoConference />
  )
}

export default VideoConferencePage